export function convertArrayOfPrimitiveToHashTable(source) {
  const distHashTable = {};
  source.forEach(item => {
    distHashTable[item] = true;
  });
  return distHashTable;
}

export function convertArrayOfObjectToHashTable(source, propertyFn) {
  const distHashTable = {};
  source.forEach(item => {
    const property = propertyFn(item);
    distHashTable[property] = item;
  });

  return distHashTable;
}
